import { useState } from 'react';

import { useEvent } from 'react-use';

export default function useIsDocumentVisible() {
  const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible');

  useEvent(
    'visibilitychange',
    () => {
      setIsVisible(document.visibilityState === 'visible');
    },
    document,
  );

  return isVisible;
}
